/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseCouncilStatsDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponsePaginatedResponseDTOCouncilWithStatsDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseSuperAdminStatsDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseUserStatisticsDTO } from '../backend/model';
// @ts-ignore
import type { Pageable } from '../backend/model';
/**
 * StatisticsControllerApi - axios parameter creator
 * @export
 */
export const StatisticsControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilStats: async (councilId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncilStats', 'councilId', councilId)
            const localVarPath = `/api/admin/stats/council/{councilId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilsWithStats: async (pageable: Pageable, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageable' is not null or undefined
            assertParamExists('getCouncilsWithStats', 'pageable', pageable)
            const localVarPath = `/api/admin/councils/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (pageable !== undefined) {
                for (const [key, value] of Object.entries(pageable)) {
                    localVarQueryParameter[key] = value;
                }
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [period] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics: async (period?: string, councilCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/statistics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (councilCode !== undefined) {
                localVarQueryParameter['councilCode'] = councilCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperAdminStats: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/stats/super-admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsControllerApi - functional programming interface
 * @export
 */
export const StatisticsControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilStats(councilId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilStatsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilStats(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getCouncilStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncilsWithStats(pageable: Pageable, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePaginatedResponseDTOCouncilWithStatsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncilsWithStats(pageable, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getCouncilsWithStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [period] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatistics(period?: string, councilCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseUserStatisticsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStatistics(period, councilCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getStatistics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSuperAdminStats(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseSuperAdminStatsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSuperAdminStats(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsControllerApi.getSuperAdminStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatisticsControllerApi - factory interface
 * @export
 */
export const StatisticsControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilStats(councilId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilStatsDTO> {
            return localVarFp.getCouncilStats(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Pageable} pageable 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncilsWithStats(pageable: Pageable, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePaginatedResponseDTOCouncilWithStatsDTO> {
            return localVarFp.getCouncilsWithStats(pageable, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [period] 
         * @param {string} [councilCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics(period?: string, councilCode?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseUserStatisticsDTO> {
            return localVarFp.getStatistics(period, councilCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSuperAdminStats(options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseSuperAdminStatsDTO> {
            return localVarFp.getSuperAdminStats(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticsControllerApi - object-oriented interface
 * @export
 * @class StatisticsControllerApi
 * @extends {BaseAPI}
 */
export class StatisticsControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getCouncilStats(councilId: number, options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getCouncilStats(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Pageable} pageable 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getCouncilsWithStats(pageable: Pageable, search?: string, options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getCouncilsWithStats(pageable, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [period] 
     * @param {string} [councilCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getStatistics(period?: string, councilCode?: string, options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getStatistics(period, councilCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticsControllerApi
     */
    public getSuperAdminStats(options?: RawAxiosRequestConfig) {
        return StatisticsControllerApiFp(this.configuration).getSuperAdminStats(options).then((request) => request(this.axios, this.basePath));
    }
}

